import { useEffect } from 'react'
import { getBoardById, getBoardComponentInfoValues, getBoardConsolidations, getBoardElementDataseries, getBoardElementDataserieValue, getBoardElementRoles, getElementsByBoardId, getHomeBoardStadistic, getBoardScopeValues, getListBoardScopeDataseries, getListBoardScopes, getElements, getHomeBoardKpiGraph, getBoardStructure, getBoardComponentInfoRecursiveValues, getBoardScopeDataseries, getBoardScopeElements, getListDataserieValueDocuments, getListDataserieDocuments } from '../../../services/sKPI/board.service';
import { getElementsDataserie, getElementRoles, getUsers, getElementsPossibleSelection, getContractByElementId, getContractHeaderByElementId  } from '../../../services/sKPI/element.service';
import { getBoardVariableDataSerieValues } from '../../../services/sKPI/dataserie.service';
import { isNullOrEmpty, isNullUndefined, parseMesAnioEs, setBoardCalendarFilterConfig, treeify } from '../../../common/Helpers';
import moment from 'moment';
import { __OBJECT_STRUCTURE_GetDataserieValue } from '../../../common/ObjectStructures/sKPI';
import { enum__BoardCalendarFilter, enum__ComponentType, enum__KPIAgregationTypes } from '../../../common/Dictionaries';
import { useDispatch } from 'react-redux';
import { action_setBoard, action_setBoardConfigElementList, action_setBoardDataseries, action_setBoardElementRoles, action_setBoardScopeValues, action_setBoardStructure, action_setEvents, action_setReportComponents_TypeText_Context, action_updateChartAction, action_updateChartActionCompare, action_updateComponentInfoData } from '../../../reducers/actions/KPI/actions';
import { getPrivilegePartyMembers, getPrivilegeRoles } from '../../../services/sPrivilege/privilege.service';

const useGetUsers = (legalEntity, usersArray, setUsersArray) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getUsers(legalEntity);

                const response = serviceResponse.data.data;
                let response_aux = treeify(response !== null ? response : [], 'userName', null, 'children', "fullName", "emailUser")

                for (let index = 0; index < response_aux.length; index++) {
                    const element = response_aux[index];
                    element.checked = false;
                    element.username = response_aux[index].userName.indexOf('\\') > 0 ? response_aux[index].userName.split('\\')[1] : response_aux[index].userName;
                }

                setUsersArray(response_aux);
            }
            catch (error) {
            }
        }
        
        if (usersArray === null) {
            getData()
        }

    }, [legalEntity, usersArray, setUsersArray]);
}

const useGetBoardConsolidations = (boardId, consolidationArray, setConsolidationArray, inputParam_IsPanelOpen) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getBoardConsolidations(boardId);

                if (serviceResponse.data.succeeded) {
                    const response = serviceResponse.data.data;

                    setConsolidationArray && setConsolidationArray(prevState => ({
                        ...prevState,
                        data: response,
                        fireUpdate:true
                    }))
                }
                else {
                    setConsolidationArray && setConsolidationArray(prevState => ({
                        ...prevState,
                        data: [],
                        fireUpdate:true
                    }))
                }
            }
            catch (error) {
                setConsolidationArray && setConsolidationArray(prevState => ({
                    ...prevState,
                    data: [],
                    fireUpdate:true
                }))
            }
        }
        
        if (boardId !== null && consolidationArray.data === null && inputParam_IsPanelOpen === true) {
            getData()
        }

    }, [boardId, consolidationArray, setConsolidationArray, inputParam_IsPanelOpen]);
}

const useGetBoardComponentInfoValuesDetail = (boardId, componentInfo, boardCalendarFilterConfig, fireSearch) => {    
    const dispatch = useDispatch();

    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getBoardComponentInfoValues(boardId, componentInfo.elementId, 11, componentInfo.dataserieId, boardCalendarFilterConfig.calendarSelectorId, boardCalendarFilterConfig.periodStartDate, boardCalendarFilterConfig.periodEndsDate);
                let response = serviceResponse.data;

                if (response.succeeded) {
                    dispatch(action_updateChartAction(false, response.data));
                }
                else {
                    dispatch(action_updateChartAction(false, null));
                }
            }
            catch (error) {
                dispatch(action_updateChartAction(false, null));
            }         
        }
        
        if ((fireSearch === true) && componentInfo !== null) {
            getData()
        }

    }, [boardId, componentInfo, boardCalendarFilterConfig, fireSearch, dispatch]);
}

const useGetBoardComponentInfoValuesDetailCompare = (boardId, componentInfo, boardCalendarFilterConfig, fireSearch) => {    
    const dispatch = useDispatch();

    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getBoardComponentInfoValues(boardId, componentInfo.elementId, 11, componentInfo.dataserieId, boardCalendarFilterConfig.calendarSelectorId, boardCalendarFilterConfig.periodStartDate, boardCalendarFilterConfig.periodEndsDate);
                let response = serviceResponse.data;

                if (response.succeeded) {
                    dispatch(action_updateChartActionCompare(false, response.data));
                }
                else {
                    dispatch(action_updateChartActionCompare(false, null));
                }
            }
            catch (error) {
                dispatch(action_updateChartActionCompare(false, null));
            }         
        }
        
        if ((fireSearch === true) && componentInfo !== null) {
            getData()
        }

    }, [boardId, componentInfo, boardCalendarFilterConfig, fireSearch, dispatch]);
}

const useGetBoardComponentInfoValues = (boardId, elementId, componentTypeId, dataserieId, calendarSelectorId, periodStartDate, periodEndsDate, elementList, setElementList) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getBoardComponentInfoValues(boardId, elementId, componentTypeId, dataserieId, calendarSelectorId, periodStartDate, periodEndsDate);
                let response = serviceResponse.data;

                if (response.succeeded) {
                    setElementList(response.data);
                }
                else {
                    setElementList([]);
                }
            }
            catch (error) {
                setElementList([]);
            }
        }
        
        if (elementList === null) {
            getData()
        }

    }, [boardId, elementId, componentTypeId, dataserieId, calendarSelectorId, periodStartDate, periodEndsDate, elementList, setElementList]);
}

const useGetBoardComponentInfoValuesSetGlobal = (boardId, elementId, componentTypeId, dataserieId, calendarSelectorId, periodStartDate, periodEndsDate, elementList) => {    
    const dispatch = useDispatch();
    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getBoardComponentInfoValues(boardId, elementId, componentTypeId, dataserieId, calendarSelectorId, periodStartDate, periodEndsDate);
                let response = serviceResponse.data;

                if (response.succeeded) {
                    dispatch(action_setEvents(response.data));

                }
                else {
                    dispatch(action_setEvents([]));
                }
            }
            catch (error) {
                dispatch(action_setEvents([]));
            }
        }
        
        if (elementList === null) {
            getData()
        }

    }, [boardId, elementId, componentTypeId, dataserieId, calendarSelectorId, periodStartDate, periodEndsDate, elementList, dispatch]);
}


const useGetBoardComponentInfoValue = (boardId, elementId, componentTypeId, dataserieId, calendarSelectorId, periodStartDate, periodEndsDate, elementList, setElementList) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getBoardComponentInfoValues(boardId, elementId, componentTypeId, dataserieId, calendarSelectorId, periodStartDate, periodEndsDate);
                let response = serviceResponse.data;

                if (response.succeeded) {
                    setElementList(response.data[0]);
                }
                else {
                    setElementList({});
                }
            }
            catch (error) {
                setElementList({});
            }
        }
        
        if (elementList === null) {
            getData()
        }

    }, [boardId, elementId, componentTypeId, dataserieId, calendarSelectorId, periodStartDate, periodEndsDate, elementList, setElementList]);
}

const useGetBoardById = (qsBoardId, boardId) => {  
    const dispatch = useDispatch();

    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getBoardById(qsBoardId);
                const response = serviceResponse.data;

                if (response.succeeded) {
                    if (response.data.length !== 0) {
                        dispatch(action_setBoard(response.data));
                    }
                    else {
                        dispatch(action_setBoard({
                            boardCode: 0,
                            creationDate: null,
                            displayCurrency: false,
                            id :0,
                            l_structure: [],
                            name: null,
                            numberFix: null,
                            owner: null,
                            timeAggregationId: null
                        }));
                    }
                }
                else {
                    dispatch(action_setBoardStructure({id :0, l_structure: []}));
                }
            }
            catch (error) {
                dispatch(action_setBoardStructure({
                    boardCode: 0,
                    creationDate: null,
                    displayCurrency: false,
                    id :0,
                    l_structure: [],
                    name: null,
                    numberFix: null,
                    owner: null,
                    timeAggregationId: null
                }));
            }
        }
        
        if (qsBoardId !== null && qsBoardId !== undefined && boardId === 0) {
            getData()
        }
    }, [qsBoardId, boardId, dispatch]);
}

const useGetBoardStructure = (qsBoardId, boardId, getNew) => {  
    const dispatch = useDispatch();

    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getBoardStructure(qsBoardId, getNew);
                const response = serviceResponse.data;

                if (response.succeeded) {
                    if (response.data.length !== 0) {
                        dispatch(action_setBoardStructure(response.data[0]));
                    }
                    else {
                        dispatch(action_setBoardStructure({
                            boardCode: 0,
                            creationDate: null,
                            displayCurrency: false,
                            id :0,
                            l_structure: [],
                            name: null,
                            numberFix: null,
                            owner: null,
                            timeAggregationId: null
                        }));
                    }
                }
                else {
                    dispatch(action_setBoardStructure({id :0, l_structure: []}));
                }
            }
            catch (error) {
                dispatch(action_setBoardStructure({
                    boardCode: 0,
                    creationDate: null,
                    displayCurrency: false,
                    id :0,
                    l_structure: [],
                    name: null,
                    numberFix: null,
                    owner: null,
                    timeAggregationId: null
                }));
            }
        }
        
        if (qsBoardId !== null && qsBoardId !== undefined && boardId === 0) {
            getData()
        }
    }, [qsBoardId, boardId, getNew, dispatch]);
}

const useGetElementRoles = (elementId, rolesArray, setRolesArray) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getElementRoles(elementId);

                setRolesArray(serviceResponse.data.data);
            }
            catch (error) {
            }
        }
        
        if (elementId !== null && rolesArray === null) {
            getData()
        }

    }, [elementId, rolesArray, setRolesArray]);
}

const useGetElementsDataserie = (elementId, elementsArray, setElementsArray, isPanelOpen) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getElementsDataserie(elementId);

                setElementsArray && setElementsArray(prevState => ({
                    ...prevState,
                    fireUpdate: true,
                    data: serviceResponse.data.data
                }));
            }
            catch (error) {
            }
        }
        
        if (elementId !== null && elementsArray.data === null && isPanelOpen) {
            getData()
        }

    }, [elementId, elementsArray, setElementsArray, isPanelOpen]);
}

const useGetElementDataSeries = (useFake, boardId, elementsArray, objDataSerieList, obJFilters) => {    
    const dispatch = useDispatch();
    
    useEffect(()=> {
        const getData = async () => {
            try {
                let elementDataseries = [];

                for (let index = 0; index < elementsArray.length; index++) {
                    const element = elementsArray[index];
                    const startDate = obJFilters.value.periodStartDate !== null ? moment(obJFilters.value.periodStartDate).format('MM/DD/YYYY') : null;
                    const endDate = obJFilters.value.periodEndsDate !== null ? moment(obJFilters.value.periodEndsDate).format('MM/DD/YYYY') : null;
                    
                    const serviceSerieResponse = await getBoardVariableDataSerieValues(boardId, element.elementId, null, obJFilters.value.calendarSelectorId, obJFilters.value.displayAgregationId, startDate, endDate);

                    elementDataseries = serviceSerieResponse.data.data
                }

                obJFilters.setter(prevState => ({
                    ...prevState,
                    fireFilter: false
                }))

                if (elementDataseries.length > 0) {
                    dispatch(action_updateComponentInfoData(elementDataseries[useFake ? 7 : 0], true));
                }
                else {
                    dispatch(action_updateComponentInfoData({}, false));
                }
                
                dispatch(action_setBoardDataseries(elementDataseries));
            }
            catch (error) {
                dispatch(action_updateComponentInfoData({}, false));
                dispatch(action_setBoardDataseries({}));
            }
        }
        
        if ((boardId !== null && boardId !== 0) && obJFilters.value.displayAgregationId !== null && elementsArray !== null && (objDataSerieList.data === null || obJFilters.value.fireFilter === true)) {
            getData()
        }

    }, [boardId, elementsArray, objDataSerieList, obJFilters, dispatch]);
}

const useGetDataSerieValues = (boardId, elementId, dataserieId, obJFilters, objDataSerieValueList, setObjDataSerieValueList, isPanelOpen) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                const startDate = obJFilters.calendarSelectorId === enum__BoardCalendarFilter.FIXED_MONTH ? obJFilters.periodStartDate !== null ? moment(obJFilters.periodStartDate).format('MM/DD/YYYY') : null : null;
                const endDate = obJFilters.calendarSelectorId === enum__BoardCalendarFilter.FIXED_MONTH ? obJFilters.periodEndsDate !== null ? moment(obJFilters.periodEndsDate).format('MM/DD/YYYY') : null : null;
                
                const serviceSerieResponse = await getBoardVariableDataSerieValues(boardId, elementId, dataserieId, obJFilters.calendarSelectorId, enum__KPIAgregationTypes.NO_AGG, startDate, endDate);

                let elementDataserie = serviceSerieResponse.data.data.find(x => x.dataserieId === dataserieId)

                setObjDataSerieValueList(prevState => ({
                    ...prevState,
                    fireUpdate:true,
                    data: elementDataserie.l_vals
                }));
            }
            catch (error) {
            }
        }
        
        if (boardId !== null && obJFilters.displayAgregationId !== null && elementId !== null && objDataSerieValueList.data === null && isPanelOpen === true) {
            getData()
        }

    }, [boardId, elementId, dataserieId, obJFilters, objDataSerieValueList, setObjDataSerieValueList, isPanelOpen]);
}

const useGetConfigurableElements = (elementsArray, setElementsArray, selectedElement, setSelectedElementType, force) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                if (selectedElement.elementType !== null) {
                    //[##]
                    let serviceResponse = await getElements(selectedElement.elementType.id);

                    if (serviceResponse.data.succeeded) {
                        setElementsArray && setElementsArray(serviceResponse.data.data);
                    }
                    else {
                        setElementsArray && setElementsArray([]);
                    }
                }
                else {
                    setElementsArray && setElementsArray([]);
                }

                setSelectedElementType && setSelectedElementType(prevState => ({
                    ...prevState,
                    fireUpdate:false,
                }));
            }
            catch (error) {
                setElementsArray && setElementsArray([]);
            }
        }
        
        if (elementsArray === null && selectedElement !== null && selectedElement.fireUpdate) {
            getData()
        }

    }, [elementsArray, setElementsArray, selectedElement, setSelectedElementType, force]);
}

const useGetContractByElementId = (element_id, contract, setContract) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getContractByElementId(element_id);

                if (serviceResponse.data.succeeded) {
                    setContract && setContract(serviceResponse.data.data);
                }
                else {
                    setContract && setContract({});
                }
            }
            catch (error) {
                setContract && setContract({});
            }
        }
        
        if (isNullUndefined(contract) && element_id !== null) {
            getData()
        }

    }, [element_id, contract, setContract]);
}

const useGetContracSimpletByElementId = (element_id, contract, setContract, boardCalendarFilterConfigValue, boardCalendarFilterConfigSetter) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                await getContractHeaderByElementId(element_id).then((response) => {
                    if (response.data.succeeded) {
                        setContract && setContract(response.data.data);
                    }
                    else {
                        setContract && setContract({});
                    }

                    const fechaInicial = moment(boardCalendarFilterConfigValue.periodStartDate)
                    const fechaFinal = moment(boardCalendarFilterConfigValue.periodEndsDate)

                    const diffMeses = fechaFinal.month() - fechaInicial.month() + 1 + (fechaFinal.year() - fechaInicial.year()) * 12;

                    if (diffMeses !== 3) {
                        const date = fechaFinal;

                        const aux_fechaInicial = date.clone().subtract(2, 'months').startOf('month').toDate();
                        const aux_fechaFinal = date.endOf('months').toDate();

                        boardCalendarFilterConfigValue.periodStartDate =aux_fechaInicial
                        boardCalendarFilterConfigValue.periodEndsDate = aux_fechaFinal
                        boardCalendarFilterConfigValue.calendarSelectorId = enum__BoardCalendarFilter.FIXED_MONTH
                        boardCalendarFilterConfigValue.fireFilter = true
                        
                        setBoardCalendarFilterConfig(boardCalendarFilterConfigValue)

                        boardCalendarFilterConfigSetter(prevState => ({
                            ...prevState,
                            fireFilter: true,
                            calendarSelectorId: enum__BoardCalendarFilter.FIXED_MONTH,
                            periodStartDate: boardCalendarFilterConfigValue.periodStartDate,
                            periodEndsDate: boardCalendarFilterConfigValue.periodEndsDate
                        }))
                    }
                }).catch((error1) => {
                    console.log(error1)
                    setContract && setContract({});
                });
            }
            catch (error2) {
                console.log(error2)
                setContract && setContract({});
            }
        }
        
        if (isNullUndefined(contract) && element_id !== null && boardCalendarFilterConfigValue !== null &&
                                                                boardCalendarFilterConfigValue.periodStartDate !== null &&
                                                                boardCalendarFilterConfigValue.periodEndsDate !== null &&
                                                                boardCalendarFilterConfigValue.calendarSelectorId !== null &&
                                                                boardCalendarFilterConfigValue.fireFilter !== null) {
            getData()
        }

    }, [element_id, contract, setContract, boardCalendarFilterConfigValue, boardCalendarFilterConfigSetter]);
}


const useGetBulkContractPartieElements = (elementsArray, setElementsArray, selectedElement) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                //[##PATH ROUTE##]
                let serviceResponse = await getElementsPossibleSelection(selectedElement, 1);

                if (serviceResponse.data.succeeded) {
                    setElementsArray && setElementsArray(serviceResponse.data.data);
                }
                else {
                    setElementsArray && setElementsArray([]);
                }
            }
            catch (error) {
                setElementsArray && setElementsArray([]);
            }
        }
        
        if (elementsArray === null && selectedElement !== null) {
            getData()
        }

    }, [elementsArray, setElementsArray, selectedElement]);
}

const useGetElements = (elementsArray, setElementsArray, selectedElement) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                if (selectedElement.key !== null) {
                    let serviceResponse = await getElements(selectedElement.key);

                    if (serviceResponse.data.succeeded) {
                        const elementList_aux = treeify(serviceResponse.data.data, 'id', "parentId", null, 'code', 'name')

                        setElementsArray && setElementsArray(elementList_aux);
                    }
                    else {
                        setElementsArray && setElementsArray([]);
                    }
                }
                else {
                    setElementsArray && setElementsArray([]);
                }
            }
            catch (error) {
                setElementsArray && setElementsArray([]);
            }
        }
        
        if (elementsArray === null && selectedElement !== null) {
            getData()
        }

    }, [elementsArray, setElementsArray, selectedElement]);
}

const useGetBoardElementDataseries = (boardId, elementId, variablesArray, setVariablesArray, parentBoardElementDataseries, setParentBoardElementDataseries) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getBoardElementDataseries(boardId, elementId);
                let newItemsToAdd = JSON.parse(JSON.stringify(parentBoardElementDataseries));

                if (serviceResponse.data.succeeded) {
                    serviceResponse.data.data.forEach(item => {
                        if (parentBoardElementDataseries.find(x => x.boardElementId === item.id) === undefined && item.id === 0) {
                            newItemsToAdd.push({
                                boardElementId: item.boardElementId,
                                dataserieId: item.dataserieId,
                                id: item.id
                            })
                        }
                    });
                    setVariablesArray(serviceResponse.data.data);
                    setParentBoardElementDataseries && setParentBoardElementDataseries(newItemsToAdd)
                }
                else {
                    setVariablesArray([])
                }

            }
            catch (error) {
                setVariablesArray([])
            }
        }
        
        if (boardId !== null && (elementId !== null && elementId !== undefined) && variablesArray === null) {
            getData()
        }

    }, [boardId, elementId, variablesArray, setVariablesArray, parentBoardElementDataseries, setParentBoardElementDataseries]);
}

const useGetBoardElementRoles = (boardId, elementId, rolesArray, setRolesArray) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getBoardElementRoles(boardId, elementId);

                setRolesArray(serviceResponse.data.data);
            }
            catch (error) {
            }
        }
        
        if (boardId !== null && (elementId !== null && elementId !== undefined) && rolesArray === null) {
            getData()
        }

    }, [boardId, elementId, rolesArray, setRolesArray]);
}

const useGetBoardElementsByBoardId = (boardId, elementsArray, setElementsArray, setSelectedElement) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponseElements = await getElementsByBoardId(boardId);

                if (serviceResponseElements.data.succeeded) {
                    const elements = serviceResponseElements.data.data;

                    for (let index = 0; index < elements.length; index++) {
                        const element = elements[index];
                        const serviceResponseRoles = await getPrivilegePartyMembers(element.elementId);
                        const serviceResponseVariables = await getBoardElementDataseries(boardId, element.elementId);

                        if (serviceResponseVariables.data.succeeded) {
                            element.l_variables = serviceResponseVariables.data.data;
                        }
                        else {
                            element.l_variables = [];
                        }


                        if (serviceResponseRoles.data.succeeded) {
                            element.l_roles = serviceResponseRoles.data.data;
                        }
                        else {
                            element.l_roles = [];
                        }

                        element._isValidElement = element.l_roles.length > 0 && element.l_variables.length > 0 && !isNullOrEmpty(element.htmlColor)
                    }

                    setElementsArray(serviceResponseElements.data.data);

                    setSelectedElement && setSelectedElement(serviceResponseElements.data.data[0])
                } 
                else {
                    setElementsArray([]);
                }
            }
            catch (error) {
                setElementsArray([]);
            }
        }
        
        if ((boardId !== null && boardId !== 0) && elementsArray === null) {
            getData()
        }

    }, [boardId, elementsArray, setElementsArray, setSelectedElement]);
}

const useGetBoardElementsByBoardIdAndElementId = (boardId, elementId, elementsArray, setElementsArray, fireGet, setFireGet) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                const serviceResponseRoles = await getPrivilegePartyMembers(elementId);
                const serviceResponseVariables = await getBoardElementDataseries(boardId, elementId);

                const element = elementsArray.find(x => x.elementId === elementId)

                if (serviceResponseVariables.data.succeeded) {
                    element.l_variables = serviceResponseVariables.data.data;
                }
                else {
                    element.l_variables = [];
                }

                if (serviceResponseRoles.data.succeeded) {
                    element.l_roles = serviceResponseRoles.data.data;
                }
                else {
                    element.l_roles = [];
                }

                element._isValidElement = element.l_roles.length > 0 && element.l_variables.length > 0 && !isNullOrEmpty(element.htmlColor)
                setFireGet(false)
                setElementsArray(elementsArray);
            }
            catch (error) {
                setFireGet(false)
                setElementsArray([]);
            }
        }
        
        if ((boardId !== null && boardId !== 0 && elementId !== null) && fireGet === true) {
            getData()
        }

    }, [boardId, elementId, elementsArray, setElementsArray, fireGet, setFireGet]);
}

const useGetBoardElementsRoles = (elementId, elementRoles) => {    
    const dispatch = useDispatch();
    
    useEffect(()=> {
        const getData = async () => {
            try {
                const serviceResponsePrivilegeMemberRoles = await getPrivilegePartyMembers(elementId);
                const serviceResponsePrivilegeRoles = await getPrivilegeRoles();

                if (serviceResponsePrivilegeMemberRoles.data.succeeded && serviceResponsePrivilegeRoles.data.succeeded) {
                    dispatch(action_setBoardElementRoles(serviceResponsePrivilegeMemberRoles.data.data, serviceResponsePrivilegeRoles.data.data))
                }
                else {
                    dispatch(action_setBoardElementRoles([], []))
                }
            }
            catch (error) {
                dispatch(action_setBoardElementRoles([], []))
            }
        }
        
        if ((elementId !== null) && elementRoles === null) {
            getData()
        }

    }, [elementId, elementRoles]);
}

const useGetListDataserieDocuments = (dataserieValueId, documentList, setDocumentLinkList, setDocumentLinkListOriginal, isPanelOpen, showDeactivatedDocuments) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getListDataserieDocuments(dataserieValueId);

                if (serviceResponse.data.succeeded === true) {
                    const response = serviceResponse.data.data;

                    if (showDeactivatedDocuments) {
                        setDocumentLinkList(response);
                    }
                    else {
                        setDocumentLinkList(response.filter(x => x.deactivate === false));
                    }

                    setDocumentLinkListOriginal(response);
                }
                else {
                    setDocumentLinkList([]);
                    setDocumentLinkListOriginal([]);
                }
            }
            catch (error) {
                setDocumentLinkList([]);
                setDocumentLinkListOriginal([]);
            }
        }
        
        if (dataserieValueId !== null && dataserieValueId !== 0 && documentList === null && isPanelOpen === true) {
            getData()
        }
    }, [dataserieValueId, documentList, setDocumentLinkList, setDocumentLinkListOriginal, isPanelOpen, showDeactivatedDocuments]);
}

const useGetListDataserieValueDocuments = (dataserieValueId, documentList, setDocumentLinkList, setDocumentLinkListOriginal, isPanelOpen, showDeactivatedDocuments) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getListDataserieValueDocuments(dataserieValueId);

                if (serviceResponse.data.succeeded === true) {
                    const response = serviceResponse.data.data;

                    if (showDeactivatedDocuments) {
                        setDocumentLinkList(response);
                    }
                    else {
                        setDocumentLinkList(response.filter(x => x.deactivate === false));
                    }

                    setDocumentLinkListOriginal(response);
                }
                else {
                    setDocumentLinkList([]);
                    setDocumentLinkListOriginal([]);
                }
            }
            catch (error) {
                setDocumentLinkList([]);
                setDocumentLinkListOriginal([]);
            }
        }
        
        if (dataserieValueId !== null && dataserieValueId !== 0 && documentList === null && isPanelOpen === true) {
            getData()
        }
    }, [dataserieValueId, documentList, setDocumentLinkList, setDocumentLinkListOriginal, isPanelOpen, showDeactivatedDocuments]);
}

const  useGetBoardElementDataserieValue = (objDataSerieValue, setObjDataSerieValue, dataserieId, serieTime, isPanelOpen) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                const ticks = moment(serieTime._d === undefined ? serieTime : serieTime._d).format('YYYYMMDDHHmmss');          
                
                let serviceResponse = await getBoardElementDataserieValue(dataserieId, null, ticks);
                const response = (serviceResponse.data.succeeded) ? serviceResponse.data.data : __OBJECT_STRUCTURE_GetDataserieValue(dataserieId);

                if (response.id === 0) {
                    setObjDataSerieValue(prevState => ({
                        ...prevState,               
                        id : response.id,
                        dataserieId: dataserieId,
                        wildcard : response.wildcard === null ? objDataSerieValue.wildcard : response.wildcard,
                        periodId : response.periodId,

                        valueGoal : response.valueGoal,
                        valueReal : response.valueReal,
                        valueProvisory : response.valueProvisory,
                        valueBudget : response.valueBudget,
                        valueForecast : response.valueForecast,
                        valueGoalPercent : response.valueGoalPercent,

                        v1 : response.v1,
                        v2 : response.v2,
                        k1 : response.k1,
                        k2 : response.k2,
                        formula : response.formula,
                        formulaDesc : response.formulaDesc,
                        locked : response.locked,
                    }))
                }
                else {
                    setObjDataSerieValue(prevState => ({
                        ...prevState,               
                        id : response.id,
                        dataserieId: response.dataserieId,
                        wildcard : response.wildcard,
                        periodId : response.periodId,

                        valueGoal : response.valueGoal,
                        valueReal : response.valueReal,
                        valueProvisory : response.valueProvisory,
                        valueBudget : response.valueBudget,
                        valueForecast : response.valueForecast,
                        valueGoalPercent : response.valueGoalPercent,

                        dd : response.dd,
                        mm : response.mm,
                        yyyy : response.yyyy,
                        serieTime : moment(response.serieTime, 'YYYYMMDDHHmmss').toDate(),
                        
                        v1 : response.v1,
                        v2 : response.v2,
                        k1 : response.k1,
                        k2 : response.k2,
                        formula : response.formula,
                        formulaDesc : response.formulaDesc,
                        
                        locked : response.locked,
                        closeProcessId : response.closeProcessId,
                    }))
                }
            }
            catch (error) {
            }
        }
        
        if ((objDataSerieValue.id === null) && dataserieId !== null && serieTime !== null && isPanelOpen === true) {
            getData()
        }
    }, [dataserieId, serieTime, objDataSerieValue, setObjDataSerieValue, isPanelOpen]);
}

const useGetHomeBoardStadistic = (calendarSelectorId, periodId, homeStadistic, setHomeStadistic) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getHomeBoardStadistic(calendarSelectorId, periodId);
                const response = serviceResponse.data;

                setHomeStadistic((response.succeeded) ? response.data : [])     
            }
            catch (error) {
            }
        }
        
        if (homeStadistic === null) {
            getData()
        }
    }, [homeStadistic, calendarSelectorId, periodId, setHomeStadistic]);
}

const useGetHomeBoardKpiGraph = (homeStadistic, setHomeStadistic) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getHomeBoardKpiGraph();
                const response = serviceResponse.data;

                setHomeStadistic((response.succeeded) ? response.data : [])     
            }
            catch (error) {
            }
        }
        
        if (homeStadistic === null) {
            getData()
        }
    }, [homeStadistic, setHomeStadistic]);
}

const useGetBoardComponentInfoValuesDynamicList = (boardId, elementId, componentTypeId, oldTypeId, calendarSelectorId, periodStartDate, periodEndsDate, elementList, setElementList, setOldType) => {
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getBoardComponentInfoValues(boardId, elementId, componentTypeId, null, calendarSelectorId, periodStartDate, periodEndsDate);
                let response = serviceResponse.data;
                let columns = [];
                let headers = [];
                let needDocumentEnabled = false;

                if (response.succeeded) {
                    switch (componentTypeId) {
                        case enum__ComponentType.SG3BOOK_EVENTOS:
                            columns = [
                                {  fieldLangKeyword: "data-lang-lbl-type", isLangKeyword: true, fieldName: "messageEventName", colAuto: false, isDate: false },
                                {  fieldLangKeyword: "data-lang-lbl-book", isLangKeyword: false, fieldName: "bookName", colAuto: false, isDate: false },
                                {  fieldLangKeyword: "data-lang-lbl-message", isLangKeyword: false, fieldName: "messageTitle", colAuto: false, isDate: false },
                                {  fieldLangKeyword: "data-lang-lbl-date", isLangKeyword: false, fieldName: "messageEventDate", colAuto: true, isDate: true }
                            ]
                            headers = [{name: 'data-lang-lbl-event'},{name: 'data-lang-lbl-actions'}]
                            break;
                        case enum__ComponentType.SG3BOOK_LIBROS:
                            columns = [
                                { fieldLangKeyword: "data-lang-lbl-name", isLangKeyword: false, fieldName: "name", colAuto: false, isDate: false },
                                { fieldLangKeyword: "data-lang-lbl-partyname", isLangKeyword: false, fieldName: "partyName", colAuto: false, isDate: false },
                                { fieldLangKeyword: "data-lang-lbl-sectionname", isLangKeyword: false, fieldName: "sectionName", colAuto: false, isDate: false },
                                { fieldLangKeyword: "data-lang-lbl-date", isLangKeyword: false, fieldName: "creationDate", colAuto: true, isDate: true }
                            ]
                            headers = [{name: 'data-lang-lbl-book'},{name: 'data-lang-lbl-actions'}]
                            break;
                        case enum__ComponentType.SG3KPI_GAPACCIONES:
                            columns = [
                                {  fieldLangKeyword: "data-lang-lbl-dataserie", isLangKeyword: false, fieldName: "gapActionParentName", colAuto: false, isDate: false },
                                {  fieldLangKeyword: "data-lang-lbl-cause", isLangKeyword: false, fieldName: "causeName", colAuto: false, isDate: false },
                                {  fieldLangKeyword: "data-lang-lbl-title", isLangKeyword: false, fieldName: "title", colAuto: false, isDate: false },
                                {  fieldLangKeyword: "data-lang-lbl-status", isLangKeyword: true, fieldName: "statusId", colAuto: true, isDate: false },
                            ]
                            headers = [{name: 'data-lang-lbl-action'},{name: 'data-lang-lbl-actions'}]
                            needDocumentEnabled = true
                            break;
                        case enum__ComponentType.SG3KPI_GAPEVENTOS:
                            columns = [
                                {  fieldLangKeyword: "data-lang-lbl-name", isLangKeyword: true, fieldName: "gapEventName", colAuto: false, isDate: false },
                                {  fieldLangKeyword: "data-lang-lbl-user", isLangKeyword: false, fieldName: "gapEventUsername", colAuto: true, isDate: false },
                                {  fieldLangKeyword: "data-lang-lbl-date", isLangKeyword: false, fieldName: "gapEventDate", colAuto: true, isDate: true },
                            ]
                            headers = [{name: 'data-lang-lbl-event'},{name: 'data-lang-lbl-actions'}]
                            needDocumentEnabled = true
                            break;
                        default:
                            break;
                    }

                    setElementList && setElementList({
                        data: response.data, 
                        showDocumentId: needDocumentEnabled, 
                        columns: columns, 
                        headers: headers
                    });
                }
                else {
                    setElementList && setElementList(prevState => ({
                        ...prevState,
                        data: []
                    }));
                }
            }
            catch (error) {
                setElementList && setElementList(prevState => ({
                    ...prevState,
                    data: []
                }));
            }

            setOldType(componentTypeId)
        }
        
        if ((elementList.data === null || (oldTypeId !== null && oldTypeId !== componentTypeId)) && boardId !== null && elementId !== null && componentTypeId !== null) {
            getData()
        }

    }, [boardId, elementId, componentTypeId, oldTypeId, calendarSelectorId, periodStartDate, periodEndsDate, elementList, setElementList, setOldType]);
}


const useGetBoardScopeElements = (scopeId, elementId, elementList, setElementList) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getBoardScopeElements(scopeId, elementId);
                const response = serviceResponse.data;

                if (response.succeeded) {
                    setElementList && setElementList(response.data)
                }
                else {
                    setElementList && setElementList([])
                }
            }
            catch (error) {
                setElementList && setElementList([])
            }
        }
        
        if ((scopeId !== null) && (elementList === null)) {
            getData()
        }
    }, [scopeId, elementId, elementList, setElementList]);
}

const useGetSkBoardScopeValues = (boardId, elementId, calendarSelectorId, displayAggregationId, periodStartDate, periodEndsDate, objBoardScopeValues) => {    
    const dispatch = useDispatch();
    
    useEffect(()=> {
        const getData = async () => {
            try {

                let serviceResponse = await getBoardScopeValues(boardId, elementId, calendarSelectorId, displayAggregationId, periodStartDate, periodEndsDate);
                const response = serviceResponse.data;

                if (response.succeeded) {
                    dispatch(action_setBoardScopeValues({objectList: response.data !== null ? response.data : []}));
                }
                else {
                    dispatch(action_setBoardScopeValues({objectList: []}));
                }
            }
            catch (error) {
                dispatch(action_setBoardScopeValues({objectList: []}));
            }
        }
        
        if ((boardId !== null && boardId !== 0) && (objBoardScopeValues === null)) {
            getData()
        }
    }, [boardId, elementId, calendarSelectorId, displayAggregationId, periodStartDate, periodEndsDate, objBoardScopeValues]);
}

const useOfGetConsolidateionList = (boardId, dataserieList, setDataserieList, setFireUpdate, isPanelOpen) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getListBoardScopes(boardId);
                const response = serviceResponse.data;

                if (response.succeeded) {
                    if (response.data !== null) {
                        setDataserieList(response.data)
                        setFireUpdate(true)
                    }
                    else {
                        setDataserieList([])
                        setFireUpdate(true)
                    }
                }
                else {
                    setDataserieList([])
                    setFireUpdate(true)
                }
            }
            catch (error) {
                setDataserieList([])
                setFireUpdate(true)
            }
        }
        
        if (boardId !== null && dataserieList === null && isPanelOpen) {
            getData()
        }
    }, [boardId, dataserieList, setDataserieList, setFireUpdate, isPanelOpen]);
}

const useGetListBoardScopeDataseries = (scopeId, elementId, scopeDataserieList, setScopeDataserieList, setObjDataserieWeightListFiltred, currentPeriodId, isPanelOpen, forceGetScopes, setForceGetScopes) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getListBoardScopeDataseries(scopeId, elementId, currentPeriodId);
                const response = serviceResponse.data;

                if (response.succeeded) {
                    if (response.data !== null) {
                        setScopeDataserieList && setScopeDataserieList(prevState => ({
                            ...prevState,
                            data: response.data,
                            fireUpdate:true
                        }))

                        setObjDataserieWeightListFiltred && setObjDataserieWeightListFiltred(prevState => ({
                            ...prevState,
                            data: response.data,
                            fireUpdate:true
                        }))
                    }
                    else {
                        setScopeDataserieList && setScopeDataserieList(prevState => ({
                            ...prevState,
                            data: [],
                            fireUpdate:true
                        }))

                        setObjDataserieWeightListFiltred && setObjDataserieWeightListFiltred(prevState => ({
                            ...prevState,
                            data: [],
                            fireUpdate:true
                        }))
                    }
                }
                else {
                    setScopeDataserieList && setScopeDataserieList(prevState => ({
                        ...prevState,
                        data: [],
                        fireUpdate:true
                    }))

                    setObjDataserieWeightListFiltred && setObjDataserieWeightListFiltred(prevState => ({
                        ...prevState,
                        data: [],
                        fireUpdate:true
                    }))
                }
                
                setForceGetScopes(false)
            }
            catch (error) {
                setScopeDataserieList && setScopeDataserieList(prevState => ({
                    ...prevState,
                    data: [],
                    fireUpdate:true
                }))

                setObjDataserieWeightListFiltred && setObjDataserieWeightListFiltred(prevState => ({
                    ...prevState,
                    data: [],
                    fireUpdate:true
                }))

                setForceGetScopes(false)
            }
        }
        
        if ((scopeId !== null && elementId !== null) && (scopeDataserieList.data === null || forceGetScopes) && currentPeriodId !== null && isPanelOpen) {
            getData()
        }
    }, [scopeId, scopeDataserieList, setScopeDataserieList, currentPeriodId, isPanelOpen, forceGetScopes, setForceGetScopes]);
}

const useGetBoardComponentInfoRecursiveValues = (componentFilters, boardReportComponentTypeText, boardId, calendarSelectorId, periodStartDate, periodEndsDate) => {    
    const dispatch = useDispatch();
    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponseTypeText = await getBoardComponentInfoRecursiveValues(componentFilters, boardId, enum__ComponentType.INFO_TYPETEXT, calendarSelectorId, periodStartDate, periodEndsDate);
                let serviceResponseInfoComment = await getBoardComponentInfoRecursiveValues(componentFilters, boardId, enum__ComponentType.INFO_COMMENT, calendarSelectorId, periodStartDate, periodEndsDate);
                let serviceResponseInfoCustomText = await getBoardComponentInfoRecursiveValues(componentFilters, boardId, enum__ComponentType.INFO_CUSTOMTEXT, calendarSelectorId, periodStartDate, periodEndsDate);
                let serviceResponseInfoFinancial = await getBoardComponentInfoRecursiveValues(componentFilters, boardId, enum__ComponentType.INFO_FINANCIAL, calendarSelectorId, periodStartDate, periodEndsDate);

                const responseTypeText = serviceResponseTypeText.data;
                const responseInfoComment = serviceResponseInfoComment.data;
                const responseInfoCustomText = serviceResponseInfoCustomText.data;
                const responseInfoFinancial = serviceResponseInfoFinancial.data;

                dispatch(action_setReportComponents_TypeText_Context({
                    infoTypeText: responseTypeText.succeeded && responseTypeText.data !== null ? responseTypeText.data : [],
                    infoComment: responseInfoComment.succeeded && responseInfoComment.data !== null ? responseInfoComment.data : [],
                    infoCustomText: responseInfoCustomText.succeeded && responseInfoCustomText.data !== null ? responseInfoCustomText.data : [],
                    infoFinancial: responseInfoFinancial.succeeded && responseInfoFinancial.data !== null ? responseInfoFinancial.data : [],
                }));
            }
            catch (error) {
                dispatch(action_setReportComponents_TypeText_Context({
                    infoTypeText: [],
                    infoComment: [],
                    infoCustomText: [],
                    infoFinancial: []
                }));
            }
        }
        
        if ((boardReportComponentTypeText === undefined || (boardReportComponentTypeText.componentTypeText === null || boardReportComponentTypeText.componentInfoComment === null)) && boardId !== 0) {
            getData()
        }
    }, [componentFilters, boardReportComponentTypeText, boardId, calendarSelectorId, periodStartDate, periodEndsDate, dispatch]);
}

export {
    useGetBoardById,
    useGetBoardStructure,
    useGetBoardElementsByBoardId,
    useGetBoardElementsByBoardIdAndElementId,
    useGetBoardElementsRoles,
    useGetElementDataSeries,
    useGetBoardElementDataseries,
    useGetConfigurableElements,
    useGetBulkContractPartieElements,
    useGetContractByElementId,
    useGetContracSimpletByElementId,
    useGetElements,
    useGetElementsDataserie,
    useGetElementRoles,
    useGetUsers,
    useGetBoardConsolidations,
    useGetBoardComponentInfoValues,
    useGetBoardComponentInfoValuesSetGlobal,
    useGetBoardComponentInfoValue,
    useGetBoardComponentInfoValuesDetail,
    useGetBoardComponentInfoValuesDetailCompare,
    useGetBoardElementRoles,
    useGetHomeBoardStadistic,
    useGetHomeBoardKpiGraph,
    useGetBoardElementDataserieValue,
    useGetListDataserieValueDocuments,
    useGetListDataserieDocuments,
    useGetDataSerieValues,
    useGetBoardComponentInfoValuesDynamicList,
    useGetListBoardScopeDataseries,
    useGetBoardScopeElements,
    useGetSkBoardScopeValues,
    useOfGetConsolidateionList,
    useGetBoardComponentInfoRecursiveValues
}